import ContentsBase from './ContentsBase';
import LegendLFM from '../legend/LegendLFM';
import { formatBaseTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_LFM } from "../../../store/WeatherContentsState";
import WRAP from 'WRAP-JS';
import TimeController from "../../map/helper/TimeController";
import Lfm from "../../map/layers/Lfm";

class ModelLFM extends ContentsBase {
  static NAME = WX_ID_LFM;
  static LFM_CHANGE_ALL = 'LFM_change_all';
  static LFM_EQV_PT = 'EqvPT';
  static LFM_ISOTACH = 'Isotach';
  static LFM_ISOTHERM = 'Isotherm';
  static LFM_TMINUS_TD = 'TMinusTD';
  static LFM_VWS = 'VWS';
  static LFM_WIND = 'Wind';
  static LFM_ICING_PROB = 'IcingProb';

  static CS_NAME = `CS_${ModelLFM.NAME}`;
  presetId = ModelLFM.CS_NAME;

  prevValidtime;
  contentsVisibleState = {
    EqvPT: true,
    Isotach: true,
    Isotherm: true,
    TMinusTD: true,
    VWS: true,
    Wind: false,
    IcingProb: true
  };
  setRevision;

  constructor(setRevision) {
    super('LFM', 'LFM', 'Model_LFM');
    this.setRevision = setRevision;
    this.timeController = new TimeController(`CS_${WX_ID_LFM}`, {
      crossSection: true,
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg).then(() => {
          if (this.timeController._parent !== null && autoFlg) {
            this.setRevision();
          }
        });
      }
    });
  }

  addObject() {
    return new Promise((resolve, reject) => {
      this.dataHandler = WRAP.DH.addObject(this.dataConfName);
      this.dataHandler.inspect(function (ref) {
        try {
          if (this._validate(ref)) {
            this.dataReference = ref;
            if(this.dataReference.query("timelist").value()) {
              this.parseTimelist();
              this.ready = true;
              this.updated = true;
              resolve();
            }
          } else {
            this.addErrorMessage('Configuration validate error.');
            reject();
          }
        } catch (e) {
          this._error(e);
          reject();
        }
      }.bind(this), false)
    });
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision()
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(date, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(date, fpMode);
        return  {
          Model: {
            Basetime: this.shownTime.basetime,
            Element: {
              ...this.contentsVisibleState
            },
            Name: "LFM",
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ModelLFM.NAME,
      label: 'LFM',
      component: LegendLFM,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ModelLFM.NAME,
      label: 'LFM',
      baseTime: this.shownTime ? formatBaseTime(this.shownTime.basetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }

  getTimeControllerInfo() {
    return {
      mapContentsId: WX_ID_LFM,
      timeController: this.timeController
    };
  }

  setContentsSettings(param) {
    Object.keys(param).forEach(k => {
      this.contentsVisibleState[k] = param[k];
    });
  }

  static resolveCsTargetName(targetName) {
    let csTargetName;
    switch (targetName) {
      case Lfm.WIND_ARROW_NAME:
        csTargetName = ModelLFM.LFM_WIND;
        break;
      case Lfm.ISOTACH_CONTOUR_NAME:
        csTargetName = ModelLFM.LFM_ISOTACH;
        break;
      case Lfm.ISOTHERM_CONTOUR_NAME:
        csTargetName = ModelLFM.LFM_ISOTHERM;
        break;
      case Lfm.ICING_PROB_NAME:
        csTargetName = ModelLFM.LFM_ICING_PROB;
        break;
      default:
        csTargetName = targetName;
        break;
    }
    return csTargetName;
  }
}

export default ModelLFM;
